module.exports = __webpack_public_path__ + "img/user-1.4c895076.png";